import React from 'react';
import { useDispatch } from 'react-redux';

import LoanApplicationDocuments from 'app/shared/modules/LoanApplicationDocuments';
import PropTypes from 'prop-types';

import { useEffectSafeStrictMode } from 'hooks/useEffectSafeStrictMode';

import { getDocumentsAction } from 'store/documents/actions';
import {
  getDocumentCategoriesAction,
  getDocumentFieldTypesAction,
  getDocumentTypesAction,
} from 'store/system/actions';

/**
 * The full Documents browser rendered inside a loan-editor side pane. It self-fetches the document
 * list + supporting types so a pane works even when opened from a non-Documents tab (the Documents
 * tab is otherwise what loads that data). `isEmbeddedInPane` gives the pane its own selection.
 */
const LoanDocumentsPaneContent = ({ loanParams }) => {
  const dispatch = useDispatch();

  useEffectSafeStrictMode(() => {
    if (!loanParams.loanIdOrLegacyLoanNumber) {
      return;
    }

    dispatch(getDocumentsAction(loanParams));
    dispatch(getDocumentFieldTypesAction());
    dispatch(getDocumentTypesAction());
    dispatch(getDocumentCategoriesAction());
  }, [dispatch, loanParams]);

  return (
    <LoanApplicationDocuments
      isDataLoaded
      isEmbeddedInPane
      isExtractedFieldsViewNeeded
      documentWrapperClassName="h-full"
      loanParams={loanParams}
    />
  );
};

LoanDocumentsPaneContent.propTypes = {
  loanParams: PropTypes.object.isRequired,
};

export default LoanDocumentsPaneContent;
